import {
  del,
  generateClient,
  isCancelError,
  post,
  put,
} from "aws-amplify/api";

const client = generateClient();

export async function requestListEbilling(dispatch, payload) {
  try {
    const {
      page,
      owner,
      limit = 10,
      createdAt,
      sortDirection = "DESC",
      nextToken = null,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_EBILLING",
      payload: { request: null, page },
    });

    const params = {
      owner,
      limit,
      createdAt,
      sortDirection,
      nextToken,
    };

    const request = client.graphql({
      query: ebillingsByOwnerCreatedAt,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_EBILLING",
      payload: { request, page },
    });

    const res = await request;

    const { items, nextToken: token } = res.data.ebillingsByOwnerCreatedAt;
    const nextPage = page + 1;

    dispatch({
      type: "LIST_EBILLING_SUCCESS",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_EBILLING_CANCEL",
      });
    } else {
      dispatch({ type: "LIST_EBILLING_ERROR", error });
    }
  }
}

export async function requestListEbillingByBusiness(dispatch, payload) {
  try {
    const {
      page,
      businessID,
      status,
      limit = 10,
      createdAt = "",
      sortDirection = "DESC",
      nextToken = null,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_EBILLING",
      payload: { request: null, page },
    });

    const filter = {
      status: {
        eq: status,
      },
    };

    const params = {
      businessID,
      filter,
      createdAt,
      limit,
      sortDirection,
      nextToken,
    };

    const request = client.graphql({
      query: ebillingsByBusinessCreatedAt,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_EBILLING",
      payload: { request, page },
    });

    const res = await request;

    const { items, nextToken: token } = res.data.ebillingsByBusinessCreatedAt;
    const nextPage = page + 1;

    dispatch({
      type: "LIST_EBILLING_SUCCESS",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_EBILLING_CANCEL",
      });
    } else {
      dispatch({ type: "LIST_EBILLING_ERROR", error });
    }
  }
}

export async function requestGetEbilling(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({ type: "REQUEST_GET_EBILLING" });

    const params = {
      id,
    };

    const res = await client.graphql({
      query: getEbilling,
      variables: params,
    });

    const ebilling = res.data.getEbilling;

    dispatch({
      type: "GET_EBILLING_SUCCESS",
      payload: { ebilling },
    });
  } catch (error) {
    dispatch({ type: "GET_EBILLING_ERROR", error });
  }
}

export async function requestCreateEbilling(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_CREATE_EBILLING" });
    const { input } = payload;
    const res = await client.graphql({
      query: createEbilling,
      variables: { input },
    });
    dispatch({
      type: "CREATE_EBILLING_SUCCESS",
      payload: { ebilling: res.data.createEbilling },
    });
  } catch (error) {
    dispatch({ type: "CREATE_EBILLING_ERROR", error });
  }
}

export async function requestCreateEbillingMass(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_CREATE_EBILLING_MASS" });
    const { items } = payload;
    const request = post({
      apiName: "ebilling",
      path: "/create",
      options: {
        body: { items },
      },
    });
    const { body } = await request.response;
    const res = await body.json();
    dispatch({
      type: "CREATE_EBILLING_MASS_SUCCESS",
      payload: { ebillings: res.data.items },
    });
  } catch (error) {
    dispatch({ type: "CREATE_EBILLING_MASS_ERROR", error });
  }
}

export async function requestListKap(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_KAP" });

    let items = [];
    let nextToken = "start";

    while (nextToken) {
      const params = { limit: 20 };
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }

      const res = await client.graphql({
        query: listAkunPajaks,
        variables: params,
      });
      items = [
        ...items,
        ...res.data.listAkunPajaks.items.map((item) => ({
          ...item,
          label: `${item.id} - ${item.name}`,
          value: item.id,
        })),
      ];
      nextToken = res.data.listAkunPajaks.nextToken;
    }

    items = items.sort((a, b) => a.id - b.id);

    dispatch({ type: "LIST_KAP_SUCCESS", payload: { items } });
  } catch (error) {
    dispatch({ type: "LIST_KAP_ERROR", error });
  }
}

export async function requestListEbillingUsage(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_EBILLING_USAGE" });

    const { userID } = payload;

    let items = [];
    let nextToken = "start";

    while (nextToken) {
      const params = { userID, limit: 20 };
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }

      const res = await client.graphql({
        query: ebillingQuotaUsagesByUser,
        variables: params,
      });
      items = [...items, ...res.data.ebillingQuotaUsagesByUser.items];
      nextToken = res.data.ebillingQuotaUsagesByUser.nextToken;
    }

    const usage = items.reduce((acc, item) => {
      return acc + item.usage;
    }, 0);

    dispatch({ type: "LIST_EBILLING_USAGE_SUCCESS", payload: { usage } });
  } catch (error) {
    dispatch({ type: "LIST_EBILLING_USAGE_ERROR", error });
  }
}

export async function requestListScheduledEbilling(dispatch, payload) {
  try {
    const {
      page,
      userID,
      limit = 10,
      createdAt = "",
      sortDirection = "DESC",
      nextToken = null,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_SCHEDULED_EBILLING",
      payload: { page },
    });

    const params = {
      limit,
      userID,
      sortDirection,
      nextToken,
    };

    if (createdAt) params.createdAt = createdAt;

    const res = await client.graphql({
      query: ebillingSchedulesByUserCreatedAt,
      variables: params,
    });

    const { items, nextToken: token } =
      res.data.ebillingSchedulesByUserCreatedAt;
    const nextPage = page + 1;

    dispatch({
      type: "LIST_SCHEDULED_EBILLING_SUCCESS",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    dispatch({ type: "LIST_SCHEDULED_EBILLING_ERROR", error });
  }
}

export async function requestCreateScheduledEbilling(dispatch, payload) {
  const { input } = payload;
  try {
    dispatch({ type: "REQUEST_CREATE_SCHEDULED_EBILLING" });

    const request = post({
      apiName: "ebilling",
      path: "/schedule",
      options: {
        body: input,
      },
    });
    const { body } = await request.response;
    const res = await body.json();
    const ebillingSchedule = res.data;

    dispatch({
      type: "SUCCESS_CREATE_SCHEDULED_EBILLING",
      payload: { ebillingSchedule },
    });
  } catch (error) {
    dispatch({ type: "ERROR_CREATE_SCHEDULED_EBILLING", error });
  }
}

export async function requestDeleteScheduledEbilling(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_DELETE_SCHEDULED_EBILLING",
      payload: { request: null },
    });
    const { id } = payload;

    const request = del({
      apiName: "ebilling",
      path: `/schedule/${id}`,
    });
    dispatch({
      type: "REQUEST_DELETE_SCHEDULED_EBILLING",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "DELETE_SCHEDULED_EBILLING_SUCCESS",
      payload: { ebillingScheduleID: res.data.id },
    });
  } catch (error) {
    dispatch({ type: "DELETE_SCHEDULED_EBILLING_ERROR", error });
  }
}

export async function requestGetScheduledEbilling(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({ type: "REQUEST_GET_SCHEDULED_EBILLING" });

    const params = {
      id,
    };

    const res = await client.graphql({
      query: getEbillingSchedule,
      variables: params,
    });

    const ebillingSchedule = res.data.getEbillingSchedule;

    if (!ebillingSchedule) throw new Error("scheduleNotFound");

    dispatch({
      type: "GET_SCHEDULED_EBILLING_SUCCESS",
      payload: { ebillingSchedule },
    });
  } catch (error) {
    dispatch({ type: "GET_SCHEDULED_EBILLING_ERROR", error });
  }
}

export async function requestUpdateScheduledEbilling(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_UPDATE_SCHEDULED_EBILLING" });
    const { input, id } = payload;

    const request = put({
      apiName: "ebilling",
      path: `/schedule/${id}`,
      options: {
        body: input,
      },
    });
    const { body } = await request.response;
    const res = await body.json();
    const ebillingSchedule = res.data;

    dispatch({
      type: "SUCCESS_UPDATE_SCHEDULED_EBILLING",
      payload: { ebillingSchedule },
    });
  } catch (error) {
    dispatch({ type: "ERROR_UPDATE_SCHEDULED_EBILLING", error });
  }
}

export async function requestBillingInputCode(dispatch, payload) {
  const { codes } = payload;
  try {
    dispatch({ type: "REQUEST_BILLING_INPUT_CODE" });

    const request = post({
      apiName: "ebilling",
      path: "/input",
      options: {
        body: { codes },
      },
    });
    const { body } = await request.response;
    const res = await body.json();
    const billingCodes = res.data.items;

    dispatch({
      type: "SUCCESS_BILLING_INPUT_CODE",
      payload: { billingCodes },
    });
  } catch (error) {
    dispatch({ type: "ERROR_BILLING_INPUT_CODE", error });
  }
}

export function resetBillingInputCode(dispatch) {
  dispatch({ type: "RESET_BILLING_INPUT_CODE" });
}

export function resetDeleteScheduledEbilling(dispatch) {
  dispatch({ type: "RESET_DELETE_SCHEDULED_EBILLING" });
}

export function resetScheduledEbilling(dispatch) {
  dispatch({ type: "RESET_SCHEDULED_EBILLING" });
}

export function resetNewEbilling(dispatch) {
  dispatch({ type: "RESET_NEW_EBILLING" });
}

export function setEbillingInitialData(dispatch, payload) {
  dispatch({ type: "SET_EBILLING_INITIAL_DATA", payload });
}

export function clearEbillingInitialData(dispatch) {
  dispatch({ type: "CLEAR_EBILLING_INITIAL_DATA" });
}

const ebillingsByOwnerCreatedAt = /* GraphQL */ `
  query EbillingsByOwnerCreatedAt(
    $owner: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEbillingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ebillingsByOwnerCreatedAt(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingId
        businessID
        business {
          id
          name
        }
        billingReference
        kapID
        kap {
          id
          name
          createdAt
          updatedAt
        }
        kjsID
        kjs {
          id
          kapID
          kjsId
          name
          hasNop
          hasSk
          hasOtherNpwp
          hasNonNpwp
          hasFilling
          wpPemungut
          wpOp
          wpBadan
          period
          createdAt
          updatedAt
        }
        startPeriod
        endPeriod
        year
        total
        nop
        skNumber
        collectorNpwp
        note
        agreeTerms
        summary {
          npwp
          kap
          kjs
          name
          email
        }
        transactionID
        transaction {
          id
          status
          orderType
          totalPay
          paymentType
          paymentNumber
          paymentDestinationName
          voucher
          totalDiscount
          actions
          userID
          description
          createdAt
          updatedAt
          expiredAt
        }
        output {
          ntpn
          ntb
          kppn
          bpn {
            key
          }
        }
        status
        error
        scheduleID
        schedule {
          id
          createPeriod
          ebillingPeriod
          ebillingYear
          date
          month
          status
          createdAt
          expiredAt
          updatedAt
        }
        createdAt
        expiredAt
        updatedAt
      }
      nextToken
    }
  }
`;

const listAkunPajaks = /* GraphQL */ `
  query ListAkunPajaks(
    $filter: ModelAkunPajakFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAkunPajaks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        kjs {
          items {
            id
            kapID
            kjsId
            name
            hasNop
            hasSk
            hasOtherNpwp
            hasNonNpwp
            hasFilling
            wpPemungut
            wpOp
            wpBadan
            period
            createdAt
            updatedAt
          }
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;

const createEbilling = /* GraphQL */ `
  mutation CreateEbilling($input: CreateEbillingInput!) {
    createEbilling(input: $input) {
      id
      billingId
      billingReference
      kapID
      kjsID
      startPeriod
      endPeriod
      year
      total
      nop
      skNumber
      collectorNpwp
      note
      agreeTerms
      summary {
        npwp
        kap
        kjs
        name
        email
      }
      transactionID
      output {
        ntpn
        ntb
        kppn
        bpn {
          key
        }
      }
      status
      error
      expiredAt
      updatedAt
      createdAt
      transaction {
        id
        status
        totalPay
        paymentType
        paymentNumber
        paymentDestinationName
        voucher
        totalDiscount
        actions
        userID
        description
        expiredAt
        createdAt
        updatedAt
      }
      kap {
        id
        name
        createdAt
        updatedAt
      }
      kjs {
        id
        kapID
        kjsId
        name
        hasNop
        hasSk
        hasOtherNpwp
        hasNonNpwp
        hasFilling
        wpPemungut
        wpOp
        wpBadan
        period
        createdAt
        updatedAt
      }
    }
  }
`;

const getEbilling = /* GraphQL */ `
  query GetEbilling($id: ID!) {
    getEbilling(id: $id) {
      id
      billingId
      billingReference
      business {
        id
        name
      }
      kapID
      kjsID
      startPeriod
      endPeriod
      year
      total
      nop
      skNumber
      collectorNpwp
      note
      agreeTerms
      summary {
        npwp
        kap
        kjs
        name
        email
      }
      transactionID
      output {
        ntpn
        ntb
        kppn
        bpn {
          key
        }
      }
      status
      error
      expiredAt
      updatedAt
      createdAt
      transaction {
        id
        status
        totalPay
        paymentType
        paymentNumber
        paymentDestinationName
        voucher
        totalDiscount
        actions
        userID
        description
        expiredAt
        createdAt
        updatedAt
      }
      kap {
        id
        name
        createdAt
        updatedAt
      }
      kjs {
        id
        kapID
        kjsId
        name
        hasNop
        hasSk
        hasOtherNpwp
        hasNonNpwp
        hasFilling
        wpPemungut
        wpOp
        wpBadan
        period
        createdAt
        updatedAt
      }
    }
  }
`;

const ebillingQuotaUsagesByUser = /* GraphQL */ `
  query EbillingQuotaUsagesByUser(
    $userID: ID
    $usage: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEbillingQuotaUsageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ebillingQuotaUsagesByUser(
      userID: $userID
      usage: $usage
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        usage
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const ebillingsByBusinessCreatedAt = /* GraphQL */ `
  query EbillingsByBusinessCreatedAt(
    $businessID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEbillingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ebillingsByBusinessCreatedAt(
      businessID: $businessID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        billingId
        businessID
        business {
          id
          name
        }
        billingReference
        kapID
        kap {
          id
          name
          createdAt
          updatedAt
        }
        kjsID
        kjs {
          id
          kapID
          kjsId
          name
          hasNop
          hasSk
          hasOtherNpwp
          hasNonNpwp
          hasFilling
          wpPemungut
          wpOp
          wpBadan
          period
          createdAt
          updatedAt
        }
        startPeriod
        endPeriod
        year
        total
        nop
        skNumber
        collectorNpwp
        note
        agreeTerms
        summary {
          npwp
          kap
          kjs
          name
          email
        }
        transactionID
        transaction {
          id
          status
          totalPay
          paymentType
          paymentNumber
          paymentDestinationName
          voucher
          totalDiscount
          actions
          userID
          description
          createdAt
          updatedAt
          expiredAt
        }
        output {
          ntpn
          ntb
          kppn
          bpn {
            key
          }
        }
        status
        error
        createdAt
        expiredAt
        updatedAt
      }
      nextToken
    }
  }
`;

const ebillingSchedulesByUserCreatedAt = /* GraphQL */ `
  query EbillingSchedulesByUserCreatedAt(
    $userID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEbillingScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ebillingSchedulesByUserCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ebilling {
          businessID
          billingReference
          kapID
          kjsID
          total
          startPeriod
          endPeriod
          nop
          skNumber
          collectorNpwp
          note
          summary {
            npwp
            kap
            kjs
            name
            email
          }
        }
        createPeriod
        ebillingPeriod
        ebillingYear
        date
        status
        month
        createdAt
        expiredAt
        updatedAt
      }
      nextToken
    }
  }
`;

const getEbillingSchedule = /* GraphQL */ `
  query GetEbillingSchedule($id: ID!) {
    getEbillingSchedule(id: $id) {
      id
      ebilling {
        businessID
        billingReference
        kapID
        kjsID
        total
        startPeriod
        endPeriod
        nop
        skNumber
        collectorNpwp
        note
        summary {
          npwp
          kap
          kjs
          name
          email
        }
      }
      createPeriod
      ebillingPeriod
      ebillingYear
      date
      month
      status
      ebillings {
        items {
          id
          billingId
          billingReference
          kapID
          kjsID
          startPeriod
          endPeriod
          year
          total
          nop
          skNumber
          collectorNpwp
          note
          agreeTerms
          summary {
            npwp
            kap
            kjs
            name
            email
          }
          transactionID
          output {
            ntpn
            ntb
            kppn
            bpn {
              bucket
              region
              key
            }
          }
          status
          error
          createdAt
          expiredAt
          createdAt
          transaction {
            id
            status
            orderType
            totalPay
            paymentType
            paymentNumber
            paymentDestinationName
            voucher
            totalDiscount
            actions
            userID
            description
            createdAt
            expiredAt
            createdAt
          }
          kap {
            id
            name
            createdAt
            createdAt
          }
          kjs {
            id
            kapID
            kjsId
            name
            hasNop
            hasSk
            hasOtherNpwp
            hasNonNpwp
            hasFilling
            wpPemungut
            wpOp
            wpBadan
            period
            createdAt
            createdAt
          }
        }
        nextToken
      }
      createdAt
      expiredAt
      updatedAt
    }
  }
`;
